import React from 'react';

import { accountHomeBaseUrl } from '@consumer-frontend/nc-api';

import { NcButton } from '../NcButton';

import '@consumer-bootstrap/netcredit.scss';

export type NcGoHomeButtonPropsT = {
  className?: string;
  onClick?: (ev?: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
};
export type NcGoHomeButtonT = React.FC<NcGoHomeButtonPropsT>;

export const NcGoHomeButton: NcGoHomeButtonT = ({ className, onClick }) => {
  return (
    <NcButton
      as="a"
      className={className}
      href={accountHomeBaseUrl}
      variant="primary"
      onClick={onClick}
    >
      Go to Account Home
    </NcButton>
  );
};
